'use strict';

const Validator = require('bunsen/validation/deprecated/Validator');
const Transaction = require('bunsen/models/ecomm/Transaction');
const LocalizedCurrencyValidation = require('bunsen/validation/deprecated/field-validations/LocalizedCurrencyValidation');
const FieldRule = require('bunsen/validation/deprecated/rules/FieldRule');
const FinancialAmount = require('bunsen/models/FinancialAmount');
const numberConversions = require('bunsen/helpers/numberConversions');
const assert = require('bunsen/helpers/assert');

const TransactionValidator = module.exports = Validator.extend({

    modelConstructor: Transaction,

    initialize(options = {}) {
        this._copy = options.copyText;
        this._compareItemPrice = typeof (options.compareItemPrice) === 'boolean' ? options.compareItemPrice : true;
        TransactionValidator.__super__.initialize.apply(this, arguments);
    },

    fieldValidations() {
        const currency = this._getCurrency(this.model);
        const isEur = currency === FinancialAmount.CURRENCY_EUR;
        const additionalRules = {
            positive: new FieldRule({
                message: this._copy.get('errorPositiveNumber'),
                validate: () => this.parseOffer(this.model) > 0
            })
        };
        if (this._compareItemPrice) {
            additionalRules.lowerThanItemPrice = new FieldRule({
                message: this._copy.get('errorUnderListPrice'),
                validate: () => Math.floor(this.parseOffer(this.model) * 100) < Math.floor(this._getItemPrice(this.model) * 100)
            });
        }
        return {
            offerAmount: new LocalizedCurrencyValidation({
                currency,
                additionalRules,
                message: isEur ? this._copy.get('errorPriceFormatEur') : this._copy.get('errorPriceFormat'),
                required: true,
                field: 'amountPerItem.amount',
                getModelValueForField: (model, field) => this._getOffer(model).get(field)
            })
        };
    },

    validateLowball(model, options) {
        model = (model instanceof this.modelConstructor) ? model : new this.modelConstructor(model);
        return this.parseOffer(model) < (this._getItemPrice(model, options) * 0.6);
    },

    validateEqualItemPrice(model) {
        model = (model instanceof this.modelConstructor) ? model : new this.modelConstructor(model);
        return this.parseOffer(model) === this._getItemPrice(model);
    },

    validateHigherItemPrice(model) {
        model = (model instanceof this.modelConstructor) ? model : new this.modelConstructor(model);
        return this.parseOffer(model) > this._getItemPrice(model);
    },

    parseOffer(model) {
        const offer = this._getOffer(model);
        const delimiter = this._getCurrency(model) === FinancialAmount.CURRENCY_EUR ? '.' : ',';
        const amount = offer.get('amountPerItem.amount') || '0';
        return numberConversions.removeThousandsDelim(amount.trim(), delimiter);
    },

    _getCurrency(model) {
        const offer = this._getOffer(model);
        return offer.get('amountPerItem.currency') || FinancialAmount.CURRENCY_USD;
    },

    _getItemPrice(model, options) {
        options = options || {};
        const item = model.get('item');
        const pricing = item ? item.get('pricing') : undefined;
        if (pricing) {
            return pricing.getMostRelevantPrice(this._getCurrency(model), options.isTrade);
        }
        return 0;
    },

    // only validate most recent offer
    _getOffer(model) {
        return model.getMostRecentOffer();
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/validation/deprecated/validators/ecom/4.3/TransactionValidator.es.js